// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.position-hack {
  position: absolute;
  left: -9999px;
}

/* .calendar {
  display: inline-block;
  color: #4a4a4a;
  position: absolute;
  left: 50%;
  top: 30px;
  transform: translate(-50%, -50%);
  width: 300px;
} */

#edit-button{
  margin-top: -6px;
  margin-bottom: -6px;
  margin-left: 12px;
}

.calendar {
  display: inline-block;
  color: #4a4a4a;
  position: absolute;
  left: 50%;
  top: 24px;
  transform: translate(-50%, -50%);
  width: 310px;
  height: 40px;
}

@media only screen and (max-width: 825px) {
  #edit-button{
    margin-top: -26px;
    margin-bottom: -6px;
    margin-left: 12px;
  }


    .calendar {
        display: inline-block;
        color: #4a4a4a;
        position: relative;
        left: -20px;
        top: 0px;
        transform: none;
        width: auto;
        margin-left: 0px;
        background: #f6f6f6;
        max-height: 40px;
        float: right;
    }
  .list-accordion i {
    font-size: 22px;
    display: inline-flex;
    vertical-align: baseline;
    margin-right: 8px;
  }
}

.prev-date {
  position: relative;
  right: 14px;
  width: 32px;
  padding: 4px;
}

.next-date {
  position: relative;
  left: 14px;
  width: 32px;
  padding: 4px;
}

.date-text {
  font-weight: bold;
  display: inline-block;
  width: 230px;
  text-align: center;
}

@media only screen and (max-width: 550px) {
  .date-text {
    width: 100px;
  }
}

.today-text{
  display: inline-block;
  text-align: center;
  width: 100%;
  float: left;
  position: relative;
  top: -39px;
  left: 0px;
}

@media only screen and (max-width: 550px) {
  .today-text {
    right: 60px;
    left: -20px;
  }
}

/* .tomorrow-text {
  position: absolute;
  top: 1px;
  right: 100px;
} */

.tomorrow-text {
  display: inline-block;
  text-align: center;
  width: 100%;
  float: left;
  position: relative;
  top: -39px;
  left: 0px;
}

@media only screen and (max-width: 825px) {
  .tomorrow-text {
    right: 44px;
    left: 0px;
    position: absolute;
    top: 0px;
  }
  .today-text {
    right: 44px;
    left: 0px;
    position: absolute;
    top: 0px;
  }
  .calendar-widget .input-group-append {
    margin-left: 30px;
  }
}

.today-button{
  position: fixed;
  cursor: pointer;
  right: 39%;
  top: 65px;
  width: 32px;
  padding: 4px;
  color: #298b57;
}

.calendar-widget input.form-control {
  opacity: 0;
  position: absolute;
  top: 17px;
  right: -22px;
}

.input-group-text {
  top: 4px;
  border: none;
  color: #298b57;
  position: absolute;
  right: -54px;
  background-color: transparent;
}

@media only screen and (max-width: 825px) {
  .input-group-text {
    top: -47px;
    right: -296px;
    position: relative;
  }
}



.input-group-text > i {
  color: #298b57;
}

.today-date-text {
  position: relative;
  top:7px;
  font-weight: bold;
  display: inline-block;
    min-width: 230px;
    text-align: center;
}

.tomorrow-date-text {
  position: relative;
  top: 7px;
  font-weight: bold;
  display: inline-block;
    min-width: 230px;
    text-align: center;
}

.input-group .odt {
  display: block;
  left: -10px;
  position: absolute;
}

.calendar-widget {

}

@media only screen and (max-width: 550px) {
  .input-group-text {
    top: 4px;
    right: -49px;
    position: absolute;
  }
  .today-date-text, .tomorrow-date-text {
      min-width: 80px;

  }
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;;;;;GAQG;;AAEH;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;;IAGE;QACI,qBAAqB;QACrB,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;EACF;IACE,eAAe;IACf,oBAAoB;IACpB,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;;AAEA;;;;GAIG;;AAEH;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;AACF;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,qBAAqB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;;AAEA;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,kBAAkB;EACpB;EACA;MACI,eAAe;;EAEnB;AACF","sourcesContent":[".position-hack {\n  position: absolute;\n  left: -9999px;\n}\n\n/* .calendar {\n  display: inline-block;\n  color: #4a4a4a;\n  position: absolute;\n  left: 50%;\n  top: 30px;\n  transform: translate(-50%, -50%);\n  width: 300px;\n} */\n\n#edit-button{\n  margin-top: -6px;\n  margin-bottom: -6px;\n  margin-left: 12px;\n}\n\n.calendar {\n  display: inline-block;\n  color: #4a4a4a;\n  position: absolute;\n  left: 50%;\n  top: 24px;\n  transform: translate(-50%, -50%);\n  width: 310px;\n  height: 40px;\n}\n\n@media only screen and (max-width: 825px) {\n  #edit-button{\n    margin-top: -26px;\n    margin-bottom: -6px;\n    margin-left: 12px;\n  }\n\n\n    .calendar {\n        display: inline-block;\n        color: #4a4a4a;\n        position: relative;\n        left: -20px;\n        top: 0px;\n        transform: none;\n        width: auto;\n        margin-left: 0px;\n        background: #f6f6f6;\n        max-height: 40px;\n        float: right;\n    }\n  .list-accordion i {\n    font-size: 22px;\n    display: inline-flex;\n    vertical-align: baseline;\n    margin-right: 8px;\n  }\n}\n\n.prev-date {\n  position: relative;\n  right: 14px;\n  width: 32px;\n  padding: 4px;\n}\n\n.next-date {\n  position: relative;\n  left: 14px;\n  width: 32px;\n  padding: 4px;\n}\n\n.date-text {\n  font-weight: bold;\n  display: inline-block;\n  width: 230px;\n  text-align: center;\n}\n\n@media only screen and (max-width: 550px) {\n  .date-text {\n    width: 100px;\n  }\n}\n\n.today-text{\n  display: inline-block;\n  text-align: center;\n  width: 100%;\n  float: left;\n  position: relative;\n  top: -39px;\n  left: 0px;\n}\n\n@media only screen and (max-width: 550px) {\n  .today-text {\n    right: 60px;\n    left: -20px;\n  }\n}\n\n/* .tomorrow-text {\n  position: absolute;\n  top: 1px;\n  right: 100px;\n} */\n\n.tomorrow-text {\n  display: inline-block;\n  text-align: center;\n  width: 100%;\n  float: left;\n  position: relative;\n  top: -39px;\n  left: 0px;\n}\n\n@media only screen and (max-width: 825px) {\n  .tomorrow-text {\n    right: 44px;\n    left: 0px;\n    position: absolute;\n    top: 0px;\n  }\n  .today-text {\n    right: 44px;\n    left: 0px;\n    position: absolute;\n    top: 0px;\n  }\n  .calendar-widget .input-group-append {\n    margin-left: 30px;\n  }\n}\n\n.today-button{\n  position: fixed;\n  cursor: pointer;\n  right: 39%;\n  top: 65px;\n  width: 32px;\n  padding: 4px;\n  color: #298b57;\n}\n\n.calendar-widget input.form-control {\n  opacity: 0;\n  position: absolute;\n  top: 17px;\n  right: -22px;\n}\n\n.input-group-text {\n  top: 4px;\n  border: none;\n  color: #298b57;\n  position: absolute;\n  right: -54px;\n  background-color: transparent;\n}\n\n@media only screen and (max-width: 825px) {\n  .input-group-text {\n    top: -47px;\n    right: -296px;\n    position: relative;\n  }\n}\n\n\n\n.input-group-text > i {\n  color: #298b57;\n}\n\n.today-date-text {\n  position: relative;\n  top:7px;\n  font-weight: bold;\n  display: inline-block;\n    min-width: 230px;\n    text-align: center;\n}\n\n.tomorrow-date-text {\n  position: relative;\n  top: 7px;\n  font-weight: bold;\n  display: inline-block;\n    min-width: 230px;\n    text-align: center;\n}\n\n.input-group .odt {\n  display: block;\n  left: -10px;\n  position: absolute;\n}\n\n.calendar-widget {\n\n}\n\n@media only screen and (max-width: 550px) {\n  .input-group-text {\n    top: 4px;\n    right: -49px;\n    position: absolute;\n  }\n  .today-date-text, .tomorrow-date-text {\n      min-width: 80px;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
